import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { Product } from "./types";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * SEO & Structured Data Utilities
 */

export function generateOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "KosherMarket",
    url: window.location.origin,
    logo: `${window.location.origin}/logo.png`,
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+1-555-KOSHER",
      contactType: "customer service",
    },
    sameAs: [
      "https://facebook.com/koshermarket",
      "https://instagram.com/koshermarket",
      "https://twitter.com/koshermarket",
    ],
  };
}

export function generateWebSiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "KosherMarket",
    url: window.location.origin,
    potentialAction: {
      "@type": "SearchAction",
      target: `${window.location.origin}/products?search={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };
}

export function generateProductSchema(
  product: Product,
  baseUrl: string,
  lang: string = "en"
) {
  const name =
    lang === "es"
      ? product.nameEs || product.name
      : lang === "he"
      ? product.nameHe || product.name
      : product.name;
  const description =
    lang === "es"
      ? product.descriptionEs || product.description
      : lang === "he"
      ? product.descriptionHe || product.description
      : product.description;

  return {
    "@context": "https://schema.org",
    "@type": "Product",
    name: name,
    image: product.imageUrl,
    description: description,
    sku: product.id.toString(),
    offers: {
      "@type": "Offer",
      url: `${baseUrl}/products?id=${product.id}`,
      priceCurrency: "MXN",
      price: product.finalPrice || product.price,
      availability:
        product.stockQuantity > 0
          ? "https://schema.org/InStock"
          : "https://schema.org/OutOfStock",
      itemCondition: "https://schema.org/NewCondition",
    },
  };
}
